import { NgModule } from '@angular/core';
import { BrowserModule, Title ,Meta} from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS,HttpClientJsonpModule } from '@angular/common/http';

import {NgxPaginationModule} from 'ngx-pagination'; 

import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TopbarComponent } from './layouts/topbar/topbar.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { LoginComponent } from './components/login/login.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AdminSidebarComponent } from './modules/admin/pages/admin-sidebar/admin-sidebar.component';
import { NewsComponent } from './modules/public/pages/news/news.component';
import { SanitizeHtmlPipe } from './shared/pipes/sanitize-html.pipe';
import { SanitizeUrlPipe } from './shared/pipes/sanitize-url.pipe';
// import { LayoutModule } from './layouts/layout.module';

import { CKEditorModule } from 'ckeditor4-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";

import { DataTablesModule } from "angular-datatables";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';

import { NgxUiLoaderModule,
  NgxUiLoaderConfig,
  NgxUiLoaderHttpModule,
  SPINNER,
  POSITION,
  PB_DIRECTION } from 'ngx-ui-loader';
import { NotfoundComponent } from './notfound/notfound.component';
import { PodcastHomeComponent } from './podcast/podcast-home/podcast-home.component';
import { PodcastDetailComponent } from './podcast/podcast-detail/podcast-detail.component';
import { PodcastComponent } from './podcast/podcast.component';


  const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    fgsColor: '#17a2b8',
    fgsPosition: POSITION.topRight,
    fgsSize: 30,
    fgsType: SPINNER.ballSpinClockwise, 
    bgsOpacity: 0.5,
    bgsPosition: POSITION.topRight,
    pbDirection: PB_DIRECTION.leftToRight, 
    pbColor: '#17a2b8',
    pbThickness: 3,
    blur:5,
    
  }
//import { DashboardComponent } from './admin/pages/dashboard/dashboard.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AngMusicPlayerModule } from  'ang-music-player';
import { MusicPlayerComponent } from './podcast/music-player/music-player.component';
import { EpisodeDetailComponent } from './podcast/episode-detail/episode-detail.component';
import { PodcastSanitizeHtmlPipe } from './shared/pipes/podcast-sanitize-html.pipe';
import { AllPodcastListComponent } from './podcast/all-podcast-list/all-podcast-list.component';
import { PodcastNewsComponent } from './podcast/podcast-news/podcast-news.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxCaptchaModule } from 'ngx-captcha';


@NgModule({
  declarations: [
    AppComponent,
    TopbarComponent,
    FooterComponent,
    ContentLayoutComponent,
    LoginComponent,
    AdminLayoutComponent,
    AdminSidebarComponent,
    NotfoundComponent,
    PodcastHomeComponent,
    PodcastDetailComponent,
    PodcastComponent,
    MusicPlayerComponent,
    EpisodeDetailComponent,
    PodcastSanitizeHtmlPipe,
    AllPodcastListComponent,
    PodcastNewsComponent,
    // NewsComponent,

    // SanitizeUrlPipe,
    // SanitizeHtmlPipe
    //DashboardComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AngMusicPlayerModule,
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    CKEditorModule,
    NgxCaptchaModule,
    // NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxSpinnerModule,
    DataTablesModule,
    MatNativeDateModule,
    MatDatepickerModule,
    NgxDaterangepickerMd.forRoot(),
    FontAwesomeModule,
    // LayoutModule
    // NgxUiLoaderHttpModule.forRoot({ showForeground: true })
    
  ],
  exports:[NgxPaginationModule, TopbarComponent,
    FooterComponent,NgxSpinnerModule],
  providers: [ Title,Meta],
  bootstrap: [AppComponent]
})
export class AppModule { }
